import React from "react";
import { NavLink } from "react-router-dom";

import { AuthenticationPage } from "../../components/shared/AuthenticationPage/AuthenticationPage";
import { Icon } from "../../components/shared/Icon/Icon";

import "./RoomDisplayCenterEol.scss";

const GOGET_CONTACT_URL = "https://gogetcorp.com/contact/";

export const RoomDisplayCenterEol = () => {
  return (
    <AuthenticationPage
      fullWidth
      header="LEGACY PLATFORM"
      headerClassname="RoomDisplayCenterEol__legacyLabel"
      formContentClassname="RoomDisplayCenterEol"
    >
      <div className="RoomDisplayCenterEol__notice" role="status">
        <Icon icon="info-icon" />
        <h1>Room Display Center is End of Life and has been replaced</h1>
      </div>

      <div className="RoomDisplayCenterEol__description">
        <p>
          Room Display Center (e.g. Room Display 6) reached End of Sales in
          2023. As planned, the platform has now reached End of Life, is no
          longer available, and has been replaced by the current GOGET platform,
          including Room Display X.
        </p>
        <p>
          If you already have an account on the current platform, log in below.
          If you&apos;re new to GOGET, create an account to get started.
        </p>
      </div>

      <div className="RoomDisplayCenterEol__actions">
        <NavLink to="/login" className="btn btn-primary">
          Log in modern platform
        </NavLink>
        <NavLink to="/register" className="btn btn-outline-primary">
          Create account
        </NavLink>
      </div>

      <div className="RoomDisplayCenterEol__support">
        <div className="RoomDisplayCenterEol__supportIcon" aria-hidden="true">
          <Icon icon="single-user-icon" />
        </div>
        <div className="RoomDisplayCenterEol__supportContent">
          <h2>Not migrated yet?</h2>
          <p>
            If, for any reason, you are still using Room Display Center and have
            not yet migrated to the current GOGET platform, please contact Goget
            Sales for assistance.
          </p>
          <a
            href={GOGET_CONTACT_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact GoGet for migration →
          </a>
        </div>
      </div>
    </AuthenticationPage>
  );
};
